export default __webpack_public_path__ + "static/winter-holidays_4-3d96c1172a080f41054a043bffae9c09.png";